// HU-30-C4 (MG-ILE-58) · tarea 30-4. Un borrador que eligió un valor de catálogo que después se
// retiró (decisión del operador): el campo lo muestra «Ovinos (retirado)» con el aviso «Este valor
// ya no se ofrece: elige otro antes de enviar», y el envío lo rechaza el servidor (422).
//
// Los dos textos llegan del servidor en `GET /casos/{id}` → `valores_retirados[]` (`campo`,
// `codigo`, `texto_del_valor`, `aviso`; AT S3 §2.2.7): la pantalla no los compone. El valor
// retirado no vuelve a la lista de `/referencias/catalogos/{c}`, que solo trae activos, así que se
// agrega a las opciones de ESE campo, y solo mientras el borrador lo conserve: en cuanto se elige
// otro, el aviso desaparece.
import type { OpcionDeSelect } from '../components/ui';

export type ValorRetirado = {
  /** El campo del caso: `animales[0].especie`, `notificante.profesion_o_rol`, `criterio_preliminar`… */
  campo: string;
  codigo: string;
  texto_del_valor: string;
  aviso: string;
};

/** El retirado de ese campo, si el formulario todavía tiene ese mismo valor. */
export const retiradoDe = (retirados: readonly ValorRetirado[] | undefined, campo: string, valorActual: unknown): ValorRetirado | undefined =>
  (retirados ?? []).find((r) => r.campo === campo && r.codigo === String(valorActual ?? ''));

/** Las opciones del catálogo más la del valor retirado, para que el desplegable lo nombre. */
export function opcionesConRetirado(opciones: OpcionDeSelect[], retirado: ValorRetirado | undefined): OpcionDeSelect[] {
  if (!retirado || opciones.some((o) => String(o.value) === retirado.codigo)) return opciones;
  return [...opciones, { value: retirado.codigo, label: retirado.texto_del_valor }];
}
